import { ImageLayer } from '../layout/types';
import { DrawnSource, sourcesDrawnByPane } from '../tile/tileViewModel';
import type { SeriesInstanceUid } from '~/domain/dicom/uids';

/**
 * The images a pane leads, as series instance uids, in the order the pane
 * draws them. An image is led by the first pane, in the row's reading
 * order, that draws it, so each image a row draws has exactly one leading
 * pane. A pane shown alone has no pane before it and leads every image it
 * draws.
 *
 * @param layer Which of the row's fused pair the pane draws.
 * @param earlierLayers The same for each image pane before it in the row's
 *   reading order; empty for the row's first image pane and for a pane
 *   shown alone.
 * @param rowImage The row's own image.
 * @param fused The row's fused secondary, if it has one.
 */
export function imagesLedByPane(
    layer: ImageLayer,
    earlierLayers: ReadonlyArray<ImageLayer>,
    rowImage: DrawnSource,
    fused: DrawnSource | undefined
): ReadonlyArray<SeriesInstanceUid> {
    const drawnBy = (paneLayer: ImageLayer): SeriesInstanceUid[] =>
        sourcesDrawnByPane(paneLayer, rowImage, fused).map(
            (image) => image.seriesInstanceUid
        );
    const drawnEarlier = new Set(earlierLayers.flatMap(drawnBy));
    return drawnBy(layer).filter((uid) => !drawnEarlier.has(uid));
}
